import React from 'react';
import QuizQuestion from './QuizQuestion.react';
import QuizStart from './QuizStart.react';
import QuizResults from './QuizResults.react';
import QuizStore from './../../stores/QuizStore.js';
import QuizActionCreators from './../../actions/QuizActionCreators.js';

class Quiz extends React.Component {
	static defaultProps = {
	  show_results: false,
	  result_id: null,
	  hide_results: false,
	  results_type: 'default',
	};

	state = {
	  quiz: [],
	  active_question: 1,
	  question: { title: '', answers: [], type: 'text' },
	  next_question: [],
	  score: 0,
	  question_count: null,
	  show_results: this.props.show_results,
	  start_page: true,
	  result_id: this.props.result_id,
	  hide_results: this.props.hide_results,
	  imagesLoaded: 0,
	  loadingImages: true,
	  results_type: this.props.results_type,
	};

	componentDidMount() {
	  QuizStore.addChangeListener(this._onChange);
	  QuizActionCreators.loadQuiz();

	  const active_question = QuizStore.getActiveQuestionIndex();
	  const quiz = QuizStore.getQuiz();
	  const question_count = quiz.question_count;
	  let next_question = [];
	  let loadingImages = true;
	  const question = QuizStore.getQuestion(active_question);

	  if (question.type == 'text') {
	    loadingImages = false;
	  }

	  if (active_question != question_count) {
	    if (active_question == null) {
	      next_question = QuizStore.getQuestion(1);
	    } else {
	      next_question = QuizStore.getQuestion(active_question + 1);
	    }
	  }

	  this.setState({
	    question,
	    next_question,
	    quiz,
	    question_count,
	    loadingImages,
	  });
	}

	getElement() {
	  if (this.state.start_page && !this.state.show_results) {
	    return (
  <QuizStart
    quiz={QuizStore.getQuiz()}
    click={e => this._handleStartClick(e)}
  />
	    );
	  }

	  if (!this.state.show_results) {
	    return (
  <QuizQuestion
    question={this.state.question}
    next_question={this.state.next_question}
    quiz={this.state.quiz}
    score={this.state.score}
    question_count={this.state.question_count}
    active_question={this.state.active_question}
    imageLoaded={e => this._handleImageLoaded(e)}
    loadingImages={this.state.loadingImages}
  />
	    );
	  }
	    return (
  <QuizResults
    quiz={this.state.quiz}
    score={this.state.score}
    question_count={this.state.question_count}
    active_question={this.state.active_question}
    click={e => this._handleResultsClick(e)}
    startClick={e => this._handleStartClick(e)}
    result_id={this.state.result_id}
    hide_results={this.props.hide_results}
    type={this.state.results_type}
  />
	    );
	}

	render() {
	  return (
	    this.getElement()
	  );
	}

	_handleStartClick = () => {
	  let score = 0;
	  const active_question = QuizStore.getActiveQuestionIndex();

	  if (this.state.question_count != null) {
	    score = ((parseInt(active_question) + 1) / parseInt(this.state.question_count)) * 100;
	  }

	  this.setState({
	    start_page: false,
	    show_results: false,
	    results_type: 'default',
	    score,
	  });
	};

	_handleImageLoaded = () => {
	  let loadingImages = false;
	  const imagesLoaded = this.state.imagesLoaded + 1;

	  if (typeof this.state.question !== 'undefined' && this.state.question.type != 'text' && this.state.question.answers.length != imagesLoaded) {
	    loadingImages = true;
	  }

	  this.setState({
	    imagesLoaded,
	    loadingImages,
	  });
	};

	_handleResultsClick = () => {
	  let loadingImages = true;
	  QuizStore.resetResults();
	  QuizStore.setActiveQuestionIndex(0);

	  const question = QuizStore.getQuestion(0);

	  if (typeof question !== 'undefined' && question.type == 'text') {
	    loadingImages = false;
	  }


	  this.setState({
	    start_page: true,
	    active_question: 1,
	    show_results: false,
	    score: 0,
	    question,
	    loadingImages,
	  });
	};

	_onChange = () => {
	  const active_question = QuizStore.getActiveQuestionIndex();
	  let show_results = false;
	  let score = 0;
	  let next_question = [];
	  let loadingImages = true;

	  if (this.state.question_count != null) {
	    score = ((parseInt(active_question) + 1) / parseInt(this.state.question_count)) * 100;
	  }

	  if (
	    this.state.question_count != null &&
			active_question == this.state.question_count
	  ) {
	    show_results = true;

	    const quiz_data = QuizStore.getQuiz();
	    const results_data = QuizStore.getResults();

	    QuizActionCreators.saveResults(results_data, quiz_data._id, this.state.hide_results);
	  }

	  if (active_question != this.state.question_count) {
	    if (active_question == null) {
	      next_question = QuizStore.getQuestion(1);
	    } else {
	      next_question = QuizStore.getQuestion(active_question + 1);
	    }
	  }

	  let question = QuizStore.getQuestion(active_question);
	  if (active_question == null) {
	    question = QuizStore.getQuestion(0);
	  }

	  if (typeof question !== 'undefined' && question.type == 'text') {
	    loadingImages = false;
	  }

	  this.setState({
	    question,
	    next_question,
	    show_results,
	    score,
	    active_question: active_question + 1,
	    result_id: null,
	    imagesLoaded: 0,
	    loadingImages,
	  });
	};
}

module.exports = Quiz;
